document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('#MobileMenu');
  const openButton = document.querySelector('[data-menu-open]');
  const closeButton = document.querySelector('[data-menu-close]');

  const setMenu = (open) => {
    if (!menu || !openButton) return;
    menu.hidden = !open;
    openButton.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('menu-open', open);
  };

  openButton?.addEventListener('click', () => setMenu(true));
  closeButton?.addEventListener('click', () => setMenu(false));
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const mainImage = section.querySelector('[data-main-product-image]');
    const thumbnails = section.querySelectorAll('[data-product-thumbnail]');
    thumbnails.forEach((button) => button.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = button.dataset.imageSrc;
      mainImage.alt = button.dataset.imageAlt || '';
      thumbnails.forEach((item) => item.classList.remove('active'));
      button.classList.add('active');
    }));

    const variantSelect = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  });
});
